/**
 * 主题工具函数
 *
 * 注意：此文件包含浏览器相关代码（import.meta.glob、currentTheme）
 * 不要在 Node.js 脚本（如 generate-theme-scss.ts）中导入此文件
 */
import { currentTheme } from "./index";
import { resolvedThemeImages } from "./theme-images-resolved";

// 重新导出颜色工具函数，保持 API 兼容性
export { generateTint, generateAlpha } from "./theme-color-utils";

/**
 * 获取主题图片的 URL
 * @param page 页面名称
 * @param name 图片名称
 * @returns 图片 URL
 *
 * 优化说明：
 * - 使用 Vite import.meta.glob 预解析的图片映射
 * - 纯 JS 对象查找，O(1) 复杂度
 * - 零 DOM 操作，避免 getComputedStyle 导致的样式重计算
 */
export function getThemeImageUrl(page: string, name: string): string {
  const themeId = currentTheme.value;
  return resolvedThemeImages[themeId]?.[page]?.[name] || "";
}

/**
 * 获取 CSS 变量表达式（用于 background-image）
 * @param page 页面名称
 * @param name 图片名称
 * @returns CSS 变量表达式
 */
export function getThemeImageVar(page: string, name: string): string {
  return `var(--${page}-${name})`;
}
